export const DEFAULT_PERMISSIONS = [
  { name: "Dashboard", value: false },
  { name: "Sale Orders", value: false },
  { name: "Purchase Orders", value: false },
  { name: "Return Orders", value: false },
  { name: "Quotes", value: false },
  { name: "Products", value: false },
  { name: "Manufacturers", value: false },
  { name: "Customers", value: false },
  { name: "Vendors", value: false },
  { name: "Settings", value: false },
  { name: "Categories", value: false },
  { name: "Sub Categories", value: false },
  { name: "Product Variant/Groups", value: false },
  { name: "Allowed Manufacturers", value: false },
  { name: "DNH Jobs", value: false },
  { name: "Tracking", value: false },
];

export const syncPermissions = (userPermissions) => {
  if (!userPermissions || !Array.isArray(userPermissions)) return DEFAULT_PERMISSIONS;

  return DEFAULT_PERMISSIONS.map((defaultPerm) => {
    const existing = userPermissions.find((p) => p.name === defaultPerm.name);
    if (existing) {
      return { ...defaultPerm, value: existing.value };
    }
    return defaultPerm;
  });
};
